<template>
    <section class="chart-container" >
        <!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters" size="mini" >
                <el-form-item label="项目名称">
					<el-select v-model="filters.projectId" multiple collapse-tags  @change="getDevices" style="width:250px" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="点位名称" >
					<el-select v-model="filters.mn"  multiple collapse-tags  @change="getFactorsByMn" style="width:320px" filterable reserve-keyword>
                        <el-option value="-1" label="全选"></el-option>
                        <el-option value="-2" label="取消全选"></el-option>
						<el-option
							v-for="item in devices"
							:label="item.name"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="设备编码" v-if="type==0">
					<el-select v-model="filters.mn"  multiple collapse-tags  @change="getFactorsByMn" style="width:280px" filterable reserve-keyword :filter-method="filterChange">
                        <el-option value="全选" label="全选"></el-option>
                        <el-option value="取消全选" label="取消全选"></el-option>
						<el-option
							v-for="item in devicesFil"
							:label="item.mnCode"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
                  <el-form-item label="因子名称">
					<el-select v-model="filters.facKeyword"  multiple collapse-tags style="width:280px" filterable>
						<el-option
							v-for="item in factors"
							:label="item.name"
							:value="item.keyword" :key="item.keyword">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="数据类型">
					<el-select v-model="dataType" placeholder="请选择数据类型" >
						<el-option label="分钟" value="min"></el-option>
						<el-option label="小时" value="hour"></el-option>
						<el-option label="天" value="day"></el-option>
					</el-select>
				</el-form-item>
             	<el-form-item label="时间范围">
					<el-date-picker
                        v-model="filters.time" type="datetimerange" unlink-panels :picker-options="pickerOptionsHour"  :default-time="dafTime" range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期"  align="right">
                    </el-date-picker>
                </el-form-item>
				<el-form-item>
                    <form-query-button   @select-type="getDataList" >  </form-query-button>
                    <export-button  @select-type="dataTableToExcel" ></export-button>
				</el-form-item>
			</el-form>
		</el-col>
     
        <!-- 折线图 -->
        <el-col :span="24"   v-loading="listLoading" class="inner">
            <div id="chartLine"></div> 
        </el-col>
        <el-col :span="24" class=" interexport">
            <el-radio-group v-model="chooseFac" id="radiogroup" @change="changeAllDevice" >
                <el-radio v-for="item in chooseFacList" :label="item.key" :key="item.key">{{item.value}}</el-radio> 
            </el-radio-group>
            <export-button   @select-type="exportClick" btnCon="图表数据导出" >  </export-button>
		</el-col>
    </section>
</template>

<script>
    import * as echarts from "echarts";
    import {getProjects,getDevicesByProjectId,getFactorsByMn,selectNoiseDataForTime,exportToExcel} from '../../api/api';
    import {formatDate,in_array} from '../../../static/fun.js';

    import FormQueryButton from '../../components/myButton/FormQueryButton.vue'
    import ExportButton from '../../components/myButton/ExportButton.vue'

	export default {
        props: {
            collapsed: {
                type: Boolean,
            },
        },
	    components: { FormQueryButton,ExportButton},
        data() {
            return {
                pickerOptionsHour: {
                    shortcuts: [{
                        text: '最近一天',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                        picker.$emit('pick', [start, end]);
                        }
                    },{
                        text: '最近一周',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                filters: {
                    mn: '',
                    facKeyword:[],
                    projectId:'',
                    time:[],
                    stationId:''
                },
                chooseFac:'',
                chooseFacList:[],
                dafTime:['00:00:00','00:00:00'],
                chartLine: null,
                projects:[],
                devices:[],
                devicesFil:[],
                copy:[],
                factors:[],
                factorName:'',
                // deviceName:[],
                data:[],
                listLoading:false,
                dataType:'hour',
                aData:[],//x轴数据
                seriesDataOra:[],//原始数据
                formHeight:0,

                legengArr:[],
                selectedLegend:{},

                type:1,

                formData: {
                    name: ''
                },
                deviceMap:new Map(),
                factorMap:new Map()
            }
        },
        watch: {
            'collapsed': {
                handler (val) {
                    if(this.chartLine!=null){
                        this.chartLine.resize();
                    }
                },
                deep: true
            },
        },
        methods: { 
             //历史数据导出信息
			dataTableToExcel(){
                 if(this.filters.mn.toString()==""){
                    this.$message({
						message: "设备MN不能为空",
						type: 'error'
					})
					return;
                }

				var starttime='';
                var endtime='';
                if(this.filters.time!=null&&this.filters.time.length>0){
                    starttime=formatDate(this.filters.time[0]);
					endtime=formatDate(this.filters.time[1]);
					
					
					//如果格式为年月日
					if(starttime.indexOf(':')==-1){
						starttime+=" 06:00:00";
						endtime+=" 05:59:59";
					}
                }
                for (let index = 0; index <   this.filters.mn.length; index++ ) {
                    let para = {
                        dataType:this.dataType,
                        mn: this.filters.mn[index],
                        startDate: starttime,
                        endDate: endtime
                    };
                    if(para.mn!=""){
                        this.exportToExcel(para);
                    }
                }
			},

            //历史数据导出信息 单台
			exportToExcel(para){
				this.listLoading = true;
				exportToExcel(para).then((res) => {
					this.listLoading = false;
					if(res.data.result=="false"||res.data.result==false){
                        this.$message({
                            message: "导出数据失败",
                            type: 'error'
                        })
                    }else{
                        var paths=res.data.data.file;
						if(paths==""||paths.indexOf(".xls")==-1){
							this.$message({
								message: "选择时间范围内暂无数据",
								type: 'success'
							});
							return;
						}
						var url=window.configuration.noParamUrl+paths;
						window.open(url, "_blank");
                    }
				}).catch(function(err) {
					this.listLoading = false;
				});
			},
            exportClick(){
                require.ensure([], () => {
                        const { export_json_to_excel } = require('vendor/Export2Excel');

                        var tHeader=[];
                        var factorName=[];
                        var mnArr=[];

                        //处理表头完毕
                        this.filters.mn.forEach((item)=>{//设备
                            mnArr.push(item);
                            if(this.type==0){
                                tHeader.push(this.deviceMap.get(item))
                            }else{
                                tHeader.push(item);
                            }
                        });
                        tHeader.unshift("时间");

                        var dataArr=[];
                        for (let index = 0; index < this.chooseFacList.length; index++) {//因子
                            const element = this.chooseFacList[index];
                            factorName.push(element.value);

                            var data=[];
                            //每个时间
                            for (let index = 0; index < this.aData.length; index++) {
                                var arr=[];
                                arr.push(JSON.parse(JSON.stringify(this.aData[index])));

                                //每台设备
                                for (let j = 0; j < mnArr.length; j++) {
                                    var mnnow=mnArr[j];
                                        const ele = this.data[mnnow][element.key];
                                        arr.push(ele[index]);
                                }
                                data.push(arr);
                            }
                            dataArr.push(data);
                        }

                        export_json_to_excel(tHeader, dataArr, '数据记录表',factorName);
                    }) 
                           
            },
            changeAllDevice(){
                this.factorName=this.factorMap.get(this.chooseFac);

                this.seriesDataOra=[];
                this.legengArr=[];
                var i=0;
                this.filters.mn.forEach((item)=>{
                    let deviceOne={};
                    deviceOne.type='line';
                    deviceOne.name=item;
                    deviceOne.connectNulls=false;//null中断

                    var dataObj = this.data[item];
                    var data= dataObj[this.chooseFac];
                    deviceOne.data=data;

                    this.legengArr.push(item);

                    if(i==0){
                        this.aData=dataObj.timeList;
                    }

                    deviceOne.smooth=true;//光滑连接
                    this.seriesDataOra.push(deviceOne);
                    i++;
                });

                this.drawLineChart(this.seriesDataOra);   
            },
            filterChange(v){
                this.copy=Object.assign([],this.devices);
                if(!in_array({mnCode:'全选'},this.copy)){
                    this.copy.push( {mnCode:'全选'});
                }
                if(!in_array({mnCode:'取消全选'},this.copy)){
                    this.copy.push( {mnCode:'取消全选'});
                }
                var dev=v.split(",");
                //对绑定数据赋值
                this.devicesFil = this.copy.filter((item) => {
                    //如果直接包含输入值直接返回true
					if (item.mnCode=="全选"||item.mnCode=="取消全选") return true;
					else if(dev.toString()==""){
						return true;
					}
					else{
						var flag=false;
						dev.forEach(element => {
							if (item.mnCode.indexOf(element) !== -1&&element!="") {
								flag=true;
                            }
						});
						return flag;
					}
                })
            },
            drawLineChart:function(seriesData) {
                 if(this.type==1){
                    this.changeMNToName(seriesData);
                } 

                var topH=parseInt(seriesData.length/8)*20+40;
                this.chartLine = echarts.init(document.getElementById('chartLine'));
                this.chartLine.setOption({
                    title: {
                        text: this.factorName+'数据趋势图'
                    },
                    tooltip: {
                        trigger: 'axis',
                        position: function(point, params, dom, rect, size){
                            //其中point为当前鼠标的位置，size中有两个属性：viewSize和contentSize，分别为外层div和tooltip提示框的大小
                            var x = point[0];//
                            var y = point[1];
                            var boxWidth = size.contentSize[0];
                            var boxHeight = size.contentSize[1];
                            var posX = 0;//x坐标位置
                            var posY = 0;//y坐标位置
                            
                            if(x<boxWidth){//左边放不开
                                posX = x+50;    
                            }else{//左边放的下
                                posX = x-boxWidth; 
                            }
                            
                            if(y<boxHeight){//上边放不开
                                if(boxHeight<400){
                                    posY=80;
                                }else{
                                    posY = -80; 
                                }
                            }else{//上边放得下
                                posY = y-boxHeight;
                            }
                            
                            return [posX,posY];
                        },
                        formatter: function(params) {
                            var flag=1;
                            var index=0;
                            if(params.length>26){
                                flag=2;
                            }
                            var result = params[0].name+'<br>';
                            params.forEach(function(item) {
                                result += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:' + item.color + '"></span>';
                                result +=item.seriesName+" : "+'<span style="display:inline-block;min-width:80px">'+ item.data+"</span>"
                                index++;
                                if(index%flag==0){
                                    result +="</br>"
                                }
                            });
                            return result;
                        },
                    },
                    toolbox: {
                        show : true,
                        feature: {
                            dataZoom: {
                                yAxisIndex:"none"
                            },
                            magicType: {show: true, type: ['line', 'bar']},
                            saveAsImage: {
                                show:true,
                                excludeComponents :['toolbox'],
                                pixelRatio: 2
                            }
                        }
                    },
                    legend: {
                        // data:this.deviceName
                         data:this.legengArr,
                         selected:this.selectedLegend
                    },
                    grid: {
                        top: topH,
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        boundaryGap: true,
                        data:this.aData
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series:seriesData
                },true);

                //判断选中图例
                var _this=this;
                this.chartLine.on('legendselectchanged', function(obj) {
                    const {selected, name} = obj;
                    _this.selectedLegend=selected; 
                });
            },
            //查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
                    this.projects = res.data.data;
                    this.listLoading = false;
                     
				});
			},
            //获取趋势分析数据
            getDataList(){
                if(this.filters.mn.toString()==""){
                    this.$message({
						message: "设备MN不能为空",
						type: 'error'
					})
					return;
                }
                var starttime='';
                var endtime='';
                if(this.filters.time!=null&&this.filters.time.length>0){
                    starttime=formatDate(this.filters.time[0]);
                    endtime=formatDate(this.filters.time[1]);
                }

                //处理因子
                this.getFactorName();

                let para = {
                    mn: this.filters.mn.toString(),
                    dataType:this.dataType,
                    factorId: this.filters.facKeyword.toString(),
                    startDate: starttime,
                    endDate: endtime,
					linkage:"false"
                };
                this.listLoading = true;
                
				selectNoiseDataForTime(para).then((res) => {
                    this.listLoading = false;
                
                    this.data = res.data;
                    this.changeAllDevice();
				});
            },
            //获取设备列表
			getDevices() {
				this.listLoading = true;
                let para = {
                    projectId: this.filters.projectId.toString(),
                };
                if(para.projectId==""){
                    return;
                }
				getDevicesByProjectId(para).then((res) => {
                    this.listLoading = false;
                    
                    this.devices = res.data.data;
                    this.devicesFil=res.data.data;
                    this.filters.mn=[];
                    if( this.devices.length>0){
                        this.filters.mn.push(res.data.data[0].mnCode);
                    }
                    this.getFactorsByMn();

                    this.deviceMap=new Map();
                    this.devices.forEach(item => {
                        this.deviceMap.set(item.mnCode,item.name)
                    });

				});
            },
            //获取选中设备可监测的因子
            getFactorsByMn(){
                // this.getDeviceName();
                if(this.filters.mn.toString()==""){
                    return;
                }
                else if(in_array('-2',this.filters.mn)||in_array('取消全选',this.filters.mn)){
                    this.filters.mn=[];
                    return;
                }
                else if(in_array('-1',this.filters.mn)||in_array('全选',this.filters.mn)){
                    this.filters.mn=[];
                    this.devicesFil.forEach(element => {
                        this.filters.mn.push(element.mnCode);
                    });
                }
                let para = {
                    mn: this.filters.mn.toString(),
                    dataType:this.dataType
                };
				getFactorsByMn(para).then((res) => {
                    
                    this.factors = res.data.data;
                    // this.filters.facKeyword=""; 
                    var facFlag=true;
                    var facTep=[];
                    this.factorMap=new Map();
                     if(this.factors.length>0){
                        this.factors.forEach(element => {
                            this.factorMap.set(element.keyword,element.name);

                            if(in_array(element.keyword,this.filters.facKeyword)){
                                facTep.push(element.keyword);
                                facFlag=false;
                            }
                        });

                        this.filters.facKeyword=facTep;
                        if(facFlag){
                            this.filters.facKeyword.push(this.factors[0].keyword); 
                        }  
                    }else{
                        this.filters.facKeyword=[];
                        this.$message({
                            message: "选择设备没有共同的因子",
                            type: 'error'
                        })
                    }
				});
            },
            //获取选中因子的名称，用于图表左侧显示
            getFactorName:function(){
                this.chooseFacList=[];
                this.chooseFac="";
                this.filters.facKeyword.forEach(element => {
                    this.chooseFacList.push({key:element,value:this.factorMap.get(element)});
                    if(this.chooseFac==""){
                        this.chooseFac=element;
                    }
                });
            }, 
            //获取选中设备的名称，用于显示图例
            changeMNToName:function(seriesData){
                this.legengArr=[];
                seriesData.forEach(item => {
                    var mnName=this.deviceMap.get(item.name);
                    item.name=mnName;
                    this.legengArr.push(mnName);
                });
            },
            SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight;
                this.formHeight=hgt-titleHgt-toolbarHgt-120;
                document.getElementById("chartLine").style.height=this.formHeight+"px";
			}
        },
        mounted: function () {
            var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)
			var end = new Date();
			var start = new Date();
			start.setTime(start.getTime() - 3600 * 1000 * 24);
            this.filters.time= [formatDate(start), formatDate(end)];
            var nowDate=end.getHours()+":00:00";
            this.dafTime=[nowDate,nowDate];
            this.getProjects();
            this.type=sessionStorage.getItem("type");

            window.onresize = function(){
                if(_this.chartLine!=null){
                    _this.chartLine.resize();
                }
            }

            Array.prototype.indexOf = function(val) { 
                for (var i = 0; i < this.length; i++) { 
                if (this[i] == val) return i; 
                } 
                return -1; 
            }; 

            Array.prototype.remove = function(val) { 
                var index = this.indexOf(val); 
                if (index > -1) { 
                this.splice(index, 1); 
                } 
            }; 
        }
    }
</script>

<style scoped>
    .el-col-1{
        text-align: center;
    }
    #innerTable{
        position: relative;
    }
    #radiogroup{
        position: absolute;
        left: 150px;
        bottom: 5px;
    }

    .interexport{
        position: relative;
    }
</style>



// WEBPACK FOOTER //
// DataExport.vue?c901e6bc